// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.showing-time-component {
  border-radius: 8px;
  position: relative;
  padding: 6px 8px;
  border: 0.5px solid white;
  height: 30px;
}
.showing-time-component .listing-time {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
}
.showing-time-component .listing-time > p {
  margin: 0;
  align-self: center;
  font-size: 10px;
  font-weight: 700;
}
.showing-time-component .listing-time > p.time {
  font-weight: 400;
}
.showing-time-component .listing-time::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 3px;
  left: 8px;
  border-radius: 12px;
  background-color: white;
}
.showing-time-component.pending {
  border-color: #06C0CD;
}
.showing-time-component.pending .listing-time::before {
  background-color: #06C0CD;
}
.showing-time-component.rejected {
  border-color: #FF3535;
}
.showing-time-component.rejected .listing-time::before {
  background-color: #FF3535;
}
.showing-time-component.approved, .showing-time-component.upcoming {
  border-color: #357DED;
}
.showing-time-component.approved .listing-time::before, .showing-time-component.upcoming .listing-time::before {
  background-color: #357DED;
}
.showing-time-component.finished {
  border-color: #36C313;
}
.showing-time-component.finished .listing-time::before {
  background-color: #36C313;
}
.showing-time-component.cancelled {
  border-color: #484848;
}
.showing-time-component.cancelled .listing-time::before {
  background-color: #484848;
}
.showing-time-component.ongoing {
  border-color: #CE1FFA;
}
.showing-time-component.ongoing .listing-time::before {
  background-color: #CE1FFA;
}`, "",{"version":3,"sources":["webpack://./src/components/ShowingTime/showingTime.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AACJ;AAAI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAER;AADQ;EACI,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAGZ;AADY;EACI,gBAAA;AAGhB;AACQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AACZ;AAGI;EACI,qBAAA;AADR;AAGQ;EACI,yBAAA;AADZ;AAKI;EACI,qBAAA;AAHR;AAKQ;EACI,yBAAA;AAHZ;AAOI;EAEI,qBAAA;AANR;AAQQ;EACI,yBAAA;AANZ;AAUI;EACI,qBAAA;AARR;AAUQ;EACI,yBAAA;AARZ;AAYI;EACI,qBAAA;AAVR;AAYQ;EACI,yBAAA;AAVZ;AAcI;EACI,qBAAA;AAZR;AAcQ;EACI,yBAAA;AAZZ","sourcesContent":[".showing-time-component {\n    border-radius: 8px;\n    position: relative;\n    padding: 6px 8px;\n    border: 0.5px solid white;\n    height: 30px;\n    .listing-time {\n        display: flex;\n        height: 100%;\n        align-items: center;\n        justify-content: space-between;\n        padding-left: 8px;\n        >p {\n            margin: 0;\n            align-self: center;\n            font-size: 10px;\n            font-weight: 700;\n\n            &.time {\n                font-weight: 400;\n            }\n        }\n\n        &::before {\n            content: \"\";\n            position: absolute;\n            height: 18px;\n            width: 3px;\n            left: 8px;\n            border-radius: 12px;\n            background-color: white;\n        }\n    }\n\n    &.pending {\n        border-color: #06C0CD;\n\n        .listing-time::before {\n            background-color: #06C0CD;\n        }\n    }\n\n    &.rejected {\n        border-color: #FF3535;\n\n        .listing-time::before {\n            background-color: #FF3535;\n        }\n    }\n\n    &.approved,\n    &.upcoming {\n        border-color: #357DED;\n\n        .listing-time::before {\n            background-color: #357DED;\n        }\n    }\n\n    &.finished {\n        border-color: #36C313;\n\n        .listing-time::before {\n            background-color: #36C313;\n        }\n    }\n\n    &.cancelled {\n        border-color: #484848;\n\n        .listing-time::before {\n            background-color: #484848;\n        }\n    }\n\n    &.ongoing {\n        border-color: #CE1FFA;\n\n        .listing-time::before {\n            background-color: #CE1FFA;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
